import { bikeI } from '../interfaces/bikes'

interface Props {
  bikes: Array<bikeI>
}

const BikeRobery = ({ bikes }: Props) => {

  return (
    <div className=" col-12  m-3">
      {bikes.length <= 0 ? (
        <p className="text-end">No results.</p>
      ) : null}
      {bikes.map((el, idx) => (
        <ul key={idx} className="list-group mb-3">

          <li className="list-group-item  p-3 d-flex justify-content-between lh-sm">
            <div className='float-start'>

              <img
                className="bg-secondary"
                width={200}
                height={200}
                alt={el.title}
                src={
                  el.thumb
                    ? el.thumb
                    : 'https://bikeindex.org/assets/revised/bike_photo_placeholder-ff15adbd9bf89e10bf3cd2cd6c4e85e5d1056e50463ae722822493624db72e56.svg'
                }
              />
            </div>
            <div className='float-end px-3 w-100'>
              <h3 className="my-0">title:{el.title}</h3>
              <p className="text-muted">description:{el.description} </p>
              <p className="text-muted">Serial: {el.serial}  </p>
              <p className="text-muted">Primary colors:
                {el.frame_colors.map((el2, inx) => (
                  <span key={inx}>{el2}</span>
                ))}
              </p>
              <p className="text-muted">
                <span style={{ color: el.stolen ? 'red' : 'none' }}>STOLEN</span>:
                {new Intl.DateTimeFormat('en-US').format(el.date_stolen)}
              </p>
              <p>Date Reported year:{el.year}</p>
              <p>Location of the theft:{el.stolen_location}</p>
              
              <a href={el.url} className='stretched-link'>Go to more details</a>

            </div>
          </li>
        </ul>
      ))
      }
    </div >
  )
}

export default BikeRobery;